import FJPaymentStore from "../../store/FJPaymentStore";
import FJCanvasStore from '../../store/FJCanvasStore'
import FJCoreConstant from "../../core/constant/FJCoreConstant";
import FJMediaStore from "../../store/FJMediaStore";
import FJMedia from '../../store/FJMedia'
import FJActionConstant from "../../constant/FJActionConstant";
import FJNetworkStore from "../../store/FJNetworkStore";
import FJViewConstant from "../../constant/FJViewConstant";
import {FJExportVideoAction, FJCloudAction, FJModalAction} from "./FJRoot.action";
import FJUtil from "../../util/FJUtil";

let FJPaymentAction = (function () {
  return {
    updateLevelAction: function () {
      return (dispatch) => {
        dispatch({
          type: FJActionConstant.UPDATE_USER_PAYMENT_LEVEL,
          paymentLevel: FJPaymentStore.getPaymentLevel(),
        });
      };
    },
    updateLimitsAction: function () {
      return (dispatch, getState) => {
        const {GET_ALL_DURATION, GET_ALL_GRAPHS, GET_WATERMARK} = FJCanvasStore.command;
        let allDuration = FJCanvasStore.executeSync(GET_ALL_DURATION);
        let allGraphs = FJCanvasStore.executeSync(GET_ALL_GRAPHS);
        let watermark = FJCanvasStore.executeSync(GET_WATERMARK);
        let stockVideoCounts = 0;

        let mediaIds = [];
        allGraphs.forEach(graph => {
          const {type, sourceId} = graph;
          let media = FJMediaStore.getMediaById(sourceId);
          if (type === FJCoreConstant.VIDEO && media && media.fromType === FJMedia.MediaFromType().STOCK && mediaIds.indexOf(sourceId) === -1) {
            stockVideoCounts++;
            mediaIds.push(sourceId)
          }
        });

        let hasCustomWM = watermark && watermark.hasWatermarkToRender();
        let limits = FJPaymentStore.getLimits(null, {
          allDuration: allDuration,
          numStockVideo: stockVideoCounts,
          hasCustomWM: hasCustomWM,
          exportSize: getState().exportVideo.qualitySelected,
        });
        dispatch({
          type: FJActionConstant.UPDATE_USER_LIMIT_STATUS,
          limits: limits,
        })
      };
    },
    upgradeLevelAction: function (source) {
      return () => {
        if (window.fjuser && window.fjuser.info && window.fjuser.info.currentPlan && window.fjuser.info.currentPlan.period === 'lifetime') {
          window.open('/lifetime')
        } else {
          if (window.openSubscription) {
            window.openSubscription(source);
          }
        }
      }
    },
    levelChangedCallbackAction: function (data) {
      return (dispatch) => {
        if (data && data.package) {
          let level = data.package;
          if (FJPaymentStore.paymentLevelConversion(level) !== FJPaymentStore.getPaymentLevel() && FJUtil.isAnonymousProject()) {
            FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
          }
          switch (level) {
            case 'basic':
              FJPaymentStore.setPaymentLevel(FJViewConstant.USER_PAYMENT_BASIC);
              break;
            case 'plus':
              FJPaymentStore.setPaymentLevel(FJViewConstant.USER_PAYMENT_PLUS);
              break;
            case 'business':
              FJPaymentStore.setPaymentLevel(FJViewConstant.USER_PAYMENT_BUSINESS);
              break;
            default:
          }
          dispatch(this.updateLimitsAction());
          dispatch(this.updateLevelAction());
          dispatch(FJExportVideoAction.updateIntroAction('NO_INTRO'));

          // 更新云存储
          dispatch(FJCloudAction.getCloudZoneAction());
          dispatch(FJCloudAction.doCheckWhenCloudSyncAction());
          dispatch(FJModalAction.setIsShowCloudBenefitModalAction(false));
        }
      };
    },
    checkLevelAction: function () {
      return (dispatch) => {
        FJNetworkStore.checkUserPaymentLevel(
          (data) => {
            if (data.code === 200 && data.data && data.data.package) {
              let level = data.data.package;
              let uLevel = '';
              switch (level) {
                case 'free':
                  uLevel = FJViewConstant.USER_PAYMENT_FREE;
                  break;
                case 'basic':
                  uLevel = FJViewConstant.USER_PAYMENT_BASIC;
                  break;
                case 'plus':
                  uLevel = FJViewConstant.USER_PAYMENT_PLUS;
                  break;
                case 'business':
                  uLevel = FJViewConstant.USER_PAYMENT_BUSINESS;
                  break;
                default:
              }
              if (uLevel && uLevel !== FJPaymentStore.getPaymentLevel()) {
                FJPaymentStore.setPaymentLevel(uLevel);
                dispatch(this.updateLimitsAction());
                dispatch(this.updateLevelAction());
                FJCanvasStore.executeSync(FJCanvasStore.command.SAVE_FOR_ONLINE);
              }
            }
          }, (err) => {
            console.log(err);
          }
        )
      };
    },
  }
})();

export default FJPaymentAction;
